import { render, staticRenderFns } from "./FormToggleSwitch.vue?vue&type=template&id=5be0e9dc&scoped=true&"
import script from "./FormToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./FormToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormToggleSwitch.vue?vue&type=style&index=0&id=5be0e9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0e9dc",
  null
  
)

export default component.exports